<template>
<div>  
    <b-table ref="tbl"
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        
        :per-page="perPage"
        :current-page="currentPage"
        primary-key="tunnus">
    </b-table>
    <!-- Filtering thousands of stops is too slow with this built-in filter functionality.
        :filter="filter"
        @filtered="onFiltered" -->
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
  
</div>    
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import stop from '@/store/timetable/stop'

export default {
    name: 'stopListTable',
    components: { TablePagination },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            fields: [
                { key:"tunnus" , label: this.$t('stop_view.id'), sortable: true },
                { key:"nimi" , label: this.$t('stop_view.name'), sortable: true },
                { key:"sms" , label: this.$t('stop_view.identifier'), sortable: true },
                { key:"laituri" , label: this.$t('stop_view.platform') }
                ],
            sortBy:"tunnus"
        }
    },
    computed: { 
        //items () { return this.$store.state.stop.stopList; },
        items () {
            var list = this.filter ?
                this.$store.state.stop.stopList.filter((stoppi) => {
                   return (stoppi.nimi && stoppi.nimi.toLowerCase().includes(this.filter.toLowerCase()))
                   || (stoppi.tunnus && stoppi.tunnus.toLowerCase().includes(this.filter.toLowerCase()))
                   || (stoppi.sms && stoppi.sms.toLowerCase().includes(this.filter.toLowerCase()))
                })
            : this.$store.state.stop.stopList;
            // Manual call added because of not using b-table built-in filtering anymore.
            this.onFiltered(list);
            
            return list;
        },
        totalRows() {
            return this.items ? this.items.length : 0;
        }               
    },
    created() {
        if (!this.$store.state.stop) {
            this.$store.registerModule("stop" , stop);
        }
        this.$store.dispatch('stop/getStopList');
    },    
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0]);        
        },
        onFiltered(filteredItems) {
            //this.totalRows = filteredItems.length
            this.currentPage = 1;
            
            if(filteredItems.length == 1){
                setTimeout(() => {
                    //console.log(this.filter) 
                    //var row = this.$refs.tbl.$el.querySelector("[data-pk='" + this.filter + "']");
                    let row = this.$refs.tbl.$el
                              .getElementsByTagName('tbody')[0]
                              .getElementsByTagName('tr')[0]
                    if(row) row.click();

                 }, 100);
            }

        },
        onPageChange(page){
            this.currentPage = page
        }
    }
}
</script>
